<form #userEditProfileFormDirective="ngForm" style=" width: 98%" [formGroup]="userEditProfileForm" [ngClass]="{'mt-[-55px]': fromSetup ? true : false}">
  <h3 class="first-title folder-view__header text-base font-bold"*ngIf="!fromSetup">
  Two Factor Authentication
    <div class="mobile-only-close">
      <button type="button" class="close add-close-button" (click)="closeDialog()">
        <i class="material-icons icons-close-mobile">close</i>
      </button>
    </div>
  </h3>

  <div class="container mx-0 px-0">
    <div class="mobile-header-divider"></div>
    <div *ngIf="!switchFromUser">
      <h3 *ngIf="fromSetup" class=" text-base font-bold">
        Set up<span class="text-[#25508E]"> Two Factor Authentication</span>
       </h3>
      <div class="two-factor-section">
        <div *ngFor="let method of methods; let i = index" class="auth-method-card" [class.primary]="method.primary">
          <div class="auth-method-info">
            <span class="auth-method-title">{{ method.name }}</span>
            <span *ngIf="method.primary" class="primary-badge">Primary</span>
          </div>
          <div class="auth-method-status">
            <span *ngIf="method.enabled" class="auth-status-badge enabled">Enabled</span>
            <span *ngIf="!method.enabled" class="auth-status-badge">Not Enabled</span>
            <button *ngIf="!method.enabled" class="enable-btn" (click)="enableMethod(i)">Enable</button>
            <div *ngIf="method.enabled && !fromSetup" class="menu-container">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon class="text-[#25508E]">more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item *ngIf="method.key === 'sms'" (click)="changePhoneNumber()">
                  <mat-icon class="text-[#25508E]">edit</mat-icon>
                  <span>Change Phone Number</span>
                </button>
                <button mat-menu-item *ngIf="method.key === 'email'" (click)="changeEmail()">
                  <mat-icon class="text-[#25508E]">edit</mat-icon>
                  <span>Change Email</span>
                </button>
                <button mat-menu-item *ngIf="!method.primary" (click)="makePrimary(i)">
                  <mat-icon class="text-[#25508E]">shield</mat-icon>
                  <span>Make Primary</span>
                </button>
                <button mat-menu-item (click)="disableMethod(i)">
                  <mat-icon color="warn">delete</mat-icon>
                  <span class="danger">Disable</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
